<template>
  <v-card>
    <v-card-title>{{ purchase.offer.title }} -- {{ purchase.user.nickname }}</v-card-title>
    <v-divider />
    <purchase-detail :purchase="purchase" />
    <v-divider />
    <v-card-row actions v-if="!purchase.accepted_at">
      <v-btn
        primary light
        @click.native.stop="accept({ id: purchase.id })">
        Accept
      </v-btn>
    </v-card-row>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import PurchaseDetail from '@/components/purchase/Availability'
export default {
  components: { PurchaseDetail },
  props: {
    purchase: {
      type: Object,
      required: true
    }
  },
  methods: mapActions({
    accept: 'skiliko/purchases/accept'
  })
}
</script>

<style>
.dialog .chat--content {
  max-height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/purchase/popup/Availability.vue